import { render, staticRenderFns } from "./CustomAttributeEditor.vue?vue&type=template&id=09db3a42&"
import script from "./CustomAttributeEditor.vue?vue&type=script&lang=ts&"
export * from "./CustomAttributeEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports